import { render, staticRenderFns } from "./imageAuthen.vue?vue&type=template&id=bcfa104a&scoped=true&"
import script from "./imageAuthen.vue?vue&type=script&lang=js&"
export * from "./imageAuthen.vue?vue&type=script&lang=js&"
import style0 from "./imageAuthen.vue?vue&type=style&index=0&id=bcfa104a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfa104a",
  null
  
)

export default component.exports